export const fieldDecimalPlaces = {
  cvsChAmount: 'cvsChAmount',
  cvsChPercent: 'cvsChPercent',
  cvsChExRate: 'cvsChExRate',
  cvsChPrice: 'cvsChPrice',
  cvsChPercent6: 'cvsChPercent6'
};
